/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S9_TitleInputs */

const en_fc_tut_s9_title = /** @type {(inputs: Fc_Tut_S9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add titles and captions`)
};

/**
* | output |
* | --- |
* | "Add titles and captions" |
*
* @param {Fc_Tut_S9_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s9_title = /** @type {((inputs?: Fc_Tut_S9_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S9_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s9_title(inputs)
});
export { fc_tut_s9_title as "fc.tut.s9.title" }